import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { IssueCard } from './issue-card'
import { type DragData } from './drag-data'
import { cn } from '@/lib/utils'
import type { WorkIssue } from '@/types/github'

// The drag harness hook lives in ./use-drag-harness so this file exports only
// a component (Vite fast-refresh requires component-only modules).

/**
 * The sortable wrapper IS the card's one interactive element (Space drags,
 * Enter opens); the inner IssueCard renders non-interactive to avoid nested
 * buttons. `disabled` omitted ⇒ always draggable.
 */
export function SortableIssue({
  issue,
  onOpen,
  disabled,
  showEffort,
  excludeContext,
}: {
  issue: WorkIssue
  onOpen: (issue: WorkIssue) => void
  disabled?: boolean
  showEffort?: boolean
  excludeContext?: string
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: issue.id,
    disabled,
    data: { issue } satisfies DragData,
  })
  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      {...attributes}
      {...listeners}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          onOpen(issue)
        }
      }}
      className={cn(
        'focus-visible:ring-ring rounded-lg focus-visible:ring-2 focus-visible:outline-none',
        isDragging && 'opacity-35',
      )}
    >
      <IssueCard
        issue={issue}
        onOpen={onOpen}
        showEffort={showEffort}
        excludeContext={excludeContext}
        interactive={false}
      />
    </div>
  )
}
